import { UserToken } from "../model";
import { apiService } from "./ApiService";

export const deriveToken = (target: string) => {
  return apiService.post<UserToken>({
    path: `v1/auth/fork`,
    // https://blacknut.atlassian.net/browse/CA-3336
    body: () => ({
      accessToken: apiService.userToken?.accessToken,
      target,
    }),
  });
};
